import axios from '@/store/axios.factory'

class UgaService {
  listar () {
    return axios.get(`/v1/uga`)
  }

  listar (cdUga) {
    return axios.get(`/v1/uga/${cdUga}`)
  }
  
  parametrizacaoAtiva (cdCategoria, cdArrecadacao) {
    let parms = '?'

    parms += (cdCategoria) ? `cdCategoria=${cdCategoria}&` : ''
    parms += (cdArrecadacao) ? `cdArrecadacao=${cdArrecadacao}&` : ''

    return axios.get(`/v1/uga/com-param-ativa-por-categoria-arrecadacao${parms}`)
  }

  comParamAtivaPorCategoria (cdCategoria) {
    let parms = '?'

    parms += (cdCategoria) ? `cdCategoria=${cdCategoria}&` : ''

    return axios.get(`/v1/uga/com-param-ativa-por-categoria${parms}`)
  }
  
  comParamAtivaPorArrecadacao(cdArrecadacao) {
    let parms = '?'

    parms += (cdArrecadacao) ? `cdArrecadacao=${cdArrecadacao}&` : ''

    return axios.get(`/v1/uga/com-param-ativa-por-arrecadacao${parms}`)
  }

}

export const ugaService = new UgaService()
